import React, { Component } from 'react';
import {connect} from 'react-redux'
import {Button,Modal,Row,Col,Form,FormGroup,FormControl,InputGroup} from 'react-bootstrap'
import FontAwsome from 'react-fontawesome'
import ReportStore from 'stores/ReportStore'
import Select from 'react-select'
import { Checkbox } from 'react-icheck'
const searchOptions = [
    {
      label: 'หมายเลขใบสั่งซื้อ',
      value: 'purchase_order_no'
    },
    {
      label: 'ใบงานเลขที่',
      value: 'work_no'
    },
    {
      label: 'ทะเบียนรถ',
      value: 'car_registration_no'
    },
    {
      label: 'ชื่อร้าน',
      value: 'shop_name'
    },
    {
      label: 'บริษัทในเครือ',
      value: 'affiliates_name'
    }
]
class POModal extends Component {

    constructor(props) {
        super(props)

        this.state = {q:'',doc:{},itemlist:[],check_itemlist:[],isCheckAll:false,searchBy:'purchase_order_no'}
    }

    componentDidMount() {

    }

    componentWillReceiveProps(newProps) {
        if (newProps.show&&newProps.show!==this.props.show) {

        }
    }

    loadData(searchBy='purchase_order_no',q='') {
        let {genItemlist} = this.props
        ReportStore.loadPurchaseOrderList('','','',searchBy,q,'','','',(result)=>{
            let check_itemlist = []
            result.data.forEach((item,index)=>{
                let checkDup = genItemlist.findIndex(x=>x.purchase_order_no===item.purchase_order_no)
                if (checkDup===-1) {
                    check_itemlist.push({doc_no:item.doc_no,isCheck:false})
                } else {
                    check_itemlist.push({doc_no:item.doc_no,isCheck:true})
                }
            })
            this.setState({itemlist:result.data,check_itemlist:check_itemlist})
            setTimeout(()=>{
                this.setState({isCheckAll:this.checkAll()})
            },100)
        })
    }

    getNumberFormat(value) {
        if(value===''||value===null||value===undefined||isNaN(value)){
          return ''
        }
        let _val = parseFloat(value)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }

    checkAll() {
        let {check_itemlist} = this.state
        let find = check_itemlist.findIndex(x=>x.isCheck===false)
		let check = false
		if (find===-1&&check_itemlist.length>0)
            check = true
        return check
    }

	onCheckboxChange(index) {
		let {check_itemlist} = this.state
		if (check_itemlist[index].isCheck)
			check_itemlist[index].isCheck = false
		else
			check_itemlist[index].isCheck = true

		this.setState({check_itemlist:check_itemlist,isCheckAll:this.checkAll()})
	}

	onCheckboxAllChange() {
		let {isCheckAll,check_itemlist} = this.state
		let new_list = []
		if (isCheckAll) {
			new_list = check_itemlist.map((item,index)=>{
				item.isCheck = false
				return item
			})
			this.setState({isCheckAll:false})
		} else {
			new_list = check_itemlist.map((item,index)=>{
				item.isCheck = true
				return item
			})
			this.setState({isCheckAll:true})
		}
		this.setState({check_itemlist:new_list})
	}

	onSelect() {
		let {check_itemlist,itemlist} = this.state
        let items = []
        itemlist.forEach((item,index)=>{
            if (check_itemlist[index].isCheck)
                items.push(item)
        })
        let datas = {itemlist:items}
		if (this.props.onSelect!==undefined)
            this.props.onSelect(datas)
    }
    
    onSearchOptionChange(val) {
        let {q} = this.state
        this.setState({searchBy:val.value})
        this.loadData(val.value,q)
      }

    onTextChange(e) {
        this.setState({q:e.target.value})
    }

    onTextKeyPress(e) {
        if (e.charCode===13) {
            e.preventDefault()

            let {q,searchBy} = this.state
            this.loadData(searchBy,q)
        }
    }

    onSearchClick() {
        let {q,searchBy} = this.state
        this.loadData(searchBy,q)
    }

    onHide() {
        this.setState({isCheckAll:false})
        this.props.onHide()
    }

    renderRowData() {
		let {itemlist,check_itemlist} = this.state
		if (itemlist.length===0) {
			return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
		} else {
			return(
				itemlist.map((item,index)=>{
					return(
						<tr key={index}>
							<td className='text-center'>
								<Checkbox
                                    onChange={this.onCheckboxChange.bind(this,index)}
                                    checked={check_itemlist[index].isCheck}
                                    checkboxClass="icheckbox_square-blue"
                                    increaseArea="20%"
                                    label={''}
                                >
                                </Checkbox>
							</td>
							<td className='text-center'>{item.purchase_order_no}</td>
							<td className='text-left'>{item.shop_name}</td>
							<td className='text-center'>{item.car_registration_no}</td>
                            <td className='text-center'>{item.brand}</td>
                            <td className='text-center'>{item.model}</td>
                            <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
						</tr>
					)
				})
			)
		}
	}

    renderTable() {
		let {isCheckAll} = this.state
		return(
			<div className='table-responsive'>
				<table className='table table-hover table-bordered-solid table-gen-doc' style={{marginBottom:'0'}}>
					<thead>
						<tr>
							<th style={{width:'50px'}} className='text-center'>
								<Checkbox
                                    onChange={this.onCheckboxAllChange.bind(this)}
                                    checked={isCheckAll}
                                    checkboxClass="icheckbox_square-blue"
                                    increaseArea="20%"
                                    label={''}
                                >
                                </Checkbox>
							</th>
                            <th className='text-center' style={{width:'100px'}}>ใบสั่งซื้อ</th>
                            <th className='text-center' style={{width:'150px'}}>ร้านสั่งซื้อ</th>
                            <th className='text-center' style={{width:'150px'}}>ทะเบียนรถ</th>
                            <th className='text-center' style={{width:'120px'}}>ยี่ห้อ</th>
                            <th className='text-center' style={{width:'120px'}}>รุ่น</th>
                            <th className='text-center' style={{width:'100px'}}>มูลค่า (บาท)</th>
						</tr>
					</thead>
					<tbody>
						{this.renderRowData()}
					</tbody>
				</table>
			</div>
		)
    }
    
    renderToolbar() {
        let {q,searchBy} = this.state
        return(
            <div>
                <Row>
                    <Col md={2}>
                        <Form>
                            <FormGroup>
                            <Select
                                value={searchBy}
                                options={searchOptions}
                                clearable={false}
                                onChange={this.onSearchOptionChange.bind(this)}
                            />
                            </FormGroup>
                        </Form>
                    </Col>
                    <Col md={4}>
                        <Form>
                            <FormGroup>
                                <InputGroup>
                                    <FormControl placeholder='ค้นหา' value={q} onChange={this.onTextChange.bind(this)} onKeyPress={this.onTextKeyPress.bind(this)} />
                                    <InputGroup.Addon onClick={this.onSearchClick.bind(this)}><FontAwsome name='search'/></InputGroup.Addon>
                                </InputGroup>  
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>
            </div>            
        )
    }

    render() {
        let {show} = this.props
        return(
            <Modal show={show} onHide={this.onHide.bind(this)} dialogClassName="midwidth-dialog">
                <Modal.Header closeButton>
                    <Modal.Title>เลือกรายการใบสั่งซื้อ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.renderToolbar()}
                    {this.renderTable()}
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle='primary' onClick={this.onSelect.bind(this)}><FontAwsome name='check' />&nbsp;เลือกรายการ</Button>
                    <Button onClick={this.onHide.bind(this)}><FontAwsome name='close' />&nbsp;ปิด</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}    

export default POModal = connect(
    (state) => ({messages: state.message.view.doc.GeneralDoc}),null,null,{withRef:true}
)(POModal);    



// WEBPACK FOOTER //
// ./src/view/doc/POModal.js